import { useMemo, useCallback } from "react"
import { useActionCable } from "~/react/hooks/useActionCable"

interface UseEmailAccountUsageProps {
  onUpdate: (accountId: number) => void
}

export const useEmailAccountUsage = ({ onUpdate }: UseEmailAccountUsageProps) => {
  const channelParams = useMemo(() => ({ channel: "EmailAccountsChannel" }), [])

  const handleReceived = useCallback(
    (data: { type: string; account_id: number }) => {
      if (data.type === "usage_update") {
        onUpdate(data.account_id)
      }
    },
    [onUpdate],
  )

  const callbacks = useMemo(() => ({ received: handleReceived }), [handleReceived])

  useActionCable({
    params: channelParams,
    callbacks,
  })
}
